// extracted by mini-css-extract-plugin
export default {"cls1":"JtPj2n4513OfKmsR1HzI","cls2":"Cw8QabuwBni6sTyLTuTh JtPj2n4513OfKmsR1HzI","isPhone":"NXlsYRCKUVrci4KEuCv4","isTabletUp":"n0YNXkr2g5MSjI8pl_bq"};